const min = 60 * 1000
const now = new Date().valueOf()
const timeFrom = now - (4 * 60 * min)
const timeTo = now

const nextCategory = (value, categoryCount) => {
  const change = Math.random() < 0.5 ? -1 : 1
  return (value + change + categoryCount) % categoryCount
}
const generateCategory = (timeFrom, timeTo, categoryCount) => {
  const values = []
  const tail = 10
  let timestamp = timeFrom
  let value = 0
  while (timestamp + tail < timeTo) {
    value = nextCategory(value, categoryCount)
    values.push([timestamp, value])
    timestamp += Math.round(Math.random() * 2 * min)
  }
  return values
}

const nextAnalogue = (valueFrom, valueTo) => Math.random() * (valueTo - valueFrom) + valueFrom
const generateAnalogue = (timeFrom, timeTo, valueFrom, valueTo) => {
  const values = []
  const tail = 10
  let timestamp = timeFrom
  let value
  while (timestamp + tail < timeTo) {
    value = nextAnalogue(valueFrom, valueTo)
    values.push([timestamp, value])
    timestamp += Math.round(Math.random() * 2 * min)
  }
  return values
}

const randomWord = () => Math.random().toString(36).substr(2, 1 + Math.random() * 10)
const nextEvent = labels => labels.map(label => ([label, randomWord()]))
const generateEvent = (timeFrom, timeTo, labels) => {
  const values = []
  let timestamp = timeFrom += Math.round(Math.random() * min)
  while (timestamp < timeTo) {
    const value = nextEvent(labels)
    values.push([timestamp, value])
    timestamp += Math.round(Math.random() * 20 * min)
  }
  return values
}

const asset11Logs = {
  name: 'TC01',
  deviceTyp: 'Discon',
  variables: [{
    name: 'Temperature °C',
    type: 'analog',
    config: { color: 'blue' },
    values: generateAnalogue(timeFrom, timeTo, -20, 50)
  }, {
    name: 'position',
    type: 'category',
    config: [
      { code: 'Free', color: 'green' },
      { code: 'Occupied', color: 'red' }
    ],
    values: generateCategory(timeFrom, timeTo, 2)
  }, {
    name: 'battery',
    type: 'category',
    config: [
      { code: 'Left', color: 'blue' },
      { code: 'Middle', color: 'blue' },
      { code: 'Right', color: 'blue' }
    ],
    values: generateCategory(timeFrom, timeTo, 3)
  }, {
    name: 'Some extremely long variable name',
    type: 'category',
    config: [
      { code: 'Aaa', color: 'green' },
      { code: 'Bbb', color: 'blue' },
      { code: 'Ccc', color: 'orange' },
      { code: 'Ddd', color: 'red' }
    ],
    values: generateCategory(timeFrom, timeTo, 4)
  }, {
    name: 'Radio 1',
    type: 'event',
    values: generateEvent(timeFrom, timeTo,
      ['Tram no', 'Direction', 'Line', 'Something longer', 'Invisible', 'Another invisible'])
  }, {
    name: 'Long variable name',
    type: 'event',
    values: generateEvent(timeFrom, timeTo, ['Tram no', 'Direction', 'Line'])
  }]
}

const asset12Logs = {
  name: 'TC02',
  deviceTyp: 'Pme',
  variables: [{
    name: 'An extremely long variable name',
    type: 'category',
    config: [
      { code: 'Free' },
      { code: 'Occupied', color: 'red' }
    ],
    values: generateCategory(timeFrom, timeTo, 2)
  }, {
    name: 'Temperature °C',
    type: 'analog',
    config: { color: 'brown' },
    values: generateAnalogue(timeFrom, timeTo, -20, 50)
  }, {
    name: 'position',
    type: 'category',
    config: [
      { code: 'Free', color: 'green' },
      { code: 'Occupied', color: 'red' }
    ],
    values: generateCategory(timeFrom, timeTo, 2)
  }, {
    name: 'Radio 1',
    type: 'event',
    values: generateEvent(timeFrom, timeTo, ['Tram no', 'Direction', 'Line'])
  }]
}

const filterValues = (timeFrom, timeTo, values) => values
  .filter(([time, _]) => time >= timeFrom && time <= timeTo)

const filterVariable = (timeFrom, timeTo, variable) =>
  ({ ...variable, values: filterValues(timeFrom, timeTo, variable.values) })

const filterVariables = (timeFrom, timeTo, variables) =>
  variables.map(variable => filterVariable(timeFrom, timeTo, variable))

const filterData = (timeFrom, timeTo, data) =>
  ({ ...data, variables: filterVariables(timeFrom, timeTo, data.variables) })

export const loadAsset11Logs = (commit, timeFrom, timeTo) => {
  const data = filterData(timeFrom, timeTo, { ...asset11Logs })
  commit('setLogs', { assetId: 11, data })
  return Promise.resolve({ data })
}

export const loadAsset12Logs = (commit, timeFrom, timeTo) => {
  const data = filterData(timeFrom, timeTo, { ...asset12Logs })
  commit('setLogs', { assetId: 12, data })
  return Promise.resolve({ data })
}
